



































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import ChoosePlanTab from '@/components/ChoosePlanTab.vue'
import ChoosePlanPrice from '@/components/ChoosePlanPrice.vue'
import { ActionTypes } from '../store/modules/customer/types'
import * as PlanUtils from '../plugins/planUtils'
import PackageContentOriginal from '../components/PackageContentOriginal.vue'
import PackageContentKids from '../components/PackageContentKids.vue'
import PackageContentFamily from '../components/PackageContentFamily.vue'
import PackageContentAdult from '../components/PackageContentAdult.vue'
import EventBanner from '../components/EventBanner.vue'

@Component({
    components: {
        ChoosePlanTab,
        ChoosePlanPrice,
        PackageContentOriginal,
        PackageContentKids,
        PackageContentFamily,
        PackageContentAdult,
        EventBanner,
    },
})
export default class ChoosePlan extends Vue {
    @Prop({ default: 'original' }) package!: string
    @Prop() isBeforeSignUp?: boolean
    packages: string[] = ['original', 'kids', 'family', 'adult']
    subscriptionTypes: string[] = ['monthly', 'threeMonths', 'twelveMonths']
    frequencies: string[] = [
        'fourLessonsPerMonth',
        'eightLessonsPerMonth',
        'thirtyLessonsPerMonth',
        'sixtyLessonsPerMonth',
    ]
    familyPackageContents: string[] = [
        'familyPackageContentEdgeHawaii',
        'familyPackageContentEdgeBusiness',
        'familyPackageContentEdgeNhk',
    ]
    adultPackageContents: string[] = [
        'adultPackageContentEdgeHawaii',
        'adultPackageContentEdgeBusiness',
    ]
    subscriptionTypesOriginalMaster: string[] = ['monthly', 'threeMonths', 'twelveMonths']
    subscriptionTypesKidFamilyMaster: string[] = ['twelveMonths']
    subscriptionTypesAdultMaster: string[] = []
    frequenciesOriginalKidsMaster: string[] = [
        'fourLessonsPerMonth',
        'eightLessonsPerMonth',
        'thirtyLessonsPerMonth',
        'sixtyLessonsPerMonth',
    ]
    frequenciesAdultMaster: string[] = [
        'fourLessonsPerMonth',
        'eightLessonsPerMonth',
        'thirtyLessonsPerMonth',
        'sixtyLessonsPerMonth',
    ]
    frequenciesFamilyMaster: string[] = ['thirtyLessonsPerMonth', 'sixtyLessonsPerMonth']
    tabPackages: string = this.package // package
    tabSubscriptionTypes: string = this.subscriptionTypes[0]
    tabFrequencies: string = this.frequencies[0]
    tabFamilyPackageContents: string = this.familyPackageContents[0]
    tabAdultPackageContents: string = this.adultPackageContents[0]
    selectedOptions: { [s: string]: any }[] = []
    selectedOption: { [s: string]: any } = {}
    packageOriginalUrlWeb =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/package_original_web.png'
    // 'https://usermodel-assets.s3.ap-northeast-1.amazonaws.com/musio-english-assets/50_campaigen_musio.png'
    packageKidsUrlWeb =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/package_kids_web_new.png'
    packageFamilyUrlWeb =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/package_family_web.png'
    packageAdultHawaiUrlWeb =
        'https://usermodel-assets.s3.ap-northeast-1.amazonaws.com/musio-english-assets/adultHawai.png'
    packageAdultBusinessUrlWeb =
        'https://usermodel-assets.s3.ap-northeast-1.amazonaws.com/musio-english-assets/adultBusiness.png'
    registrationOriginal =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/registration_original.png'
    registrationKids =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/registration_kids.png'
    registrationFamily =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/registration_family.png'
    registrationAdult =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/registration_adult.png'

    get selectedTabColor() {
        if (this.tabPackages === 'kids') {
            return {
                color: '#e20707',
                background: '#FFDDDD',
            }
        } else if (this.tabPackages === 'family') {
            return {
                color: '#0d61d1',
                background: '#BFD2FF',
            }
        } else if (this.tabPackages === 'adult') {
            return {
                color: '#0D61D1',
                background: '#BFD2FF',
            }
        } else {
            return {
                // Default: original
                color: '#087426',
                background: '#E2FFDD',
            }
        }
    }

    get price() {
        if (
            this.selectedOption.length !== 0 &&
            this.selectedOption[0] != null &&
            this.selectedOption[0].price != null
        ) {
            return this.selectedOption[0].price
        } else {
            return 0
        }
    }
    get originalPrice() {
        if (
            this.selectedOption.length !== 0 &&
            this.selectedOption[0] != null &&
            this.selectedOption[0].original_price != null
        ) {
            return this.selectedOption[0].original_price
        } else {
            return 0
        }
    }

    get preDiscountPrice() {
        if (this.selectedOption.length !== 0) {
            return this.selectedOption[0]?.pre_discount_price ?? 0
        } else {
            return 0
        }
    }
    get discountRate() {
        if (
            this.selectedOption.length !== 0 &&
            this.selectedOption[0] != null &&
            this.selectedOption[0].discount_rate != null
        ) {
            return this.selectedOption[0].discount_rate
        } else {
            return 0
        }
    }

    get contractMonth() {
        if (
            this.selectedOption.length !== 0 &&
            this.selectedOption[0] != null &&
            this.selectedOption[0].contract_month != null
        ) {
            return this.selectedOption[0].contract_month
        } else {
            return 0
        }
    }
    get optionId() {
        if (
            this.selectedOption.length !== 0 &&
            this.selectedOption[0] != null &&
            this.selectedOption[0].id != null
        ) {
            return this.selectedOption[0].id
        } else {
            return ''
        }
    }
    // Depend on the selected "package", change "tab" contents
    packageChanged(): void {
        this.subscriptionTypes.splice(-this.subscriptionTypes.length)
        this.frequencies.splice(-this.frequencies.length)
        if (this.tabPackages === 'family') {
            Object.assign(this.subscriptionTypes, this.subscriptionTypesKidFamilyMaster)
            Object.assign(this.frequencies, this.frequenciesFamilyMaster)
        } else if (this.tabPackages === 'kids') {
            Object.assign(this.subscriptionTypes, this.subscriptionTypesKidFamilyMaster)
            Object.assign(this.frequencies, this.frequenciesOriginalKidsMaster)
        } else if (this.tabPackages == 'adult') {
            Object.assign(this.subscriptionTypes, this.subscriptionTypesAdultMaster)
            Object.assign(this.frequencies, this.frequenciesAdultMaster)
        } else {
            Object.assign(this.subscriptionTypes, this.subscriptionTypesOriginalMaster)
            Object.assign(this.frequencies, this.frequenciesOriginalKidsMaster)
        }
    }
    getResult(): void {
        let optionId: string = PlanUtils.getOptionId(
            this.tabPackages,
            this.tabSubscriptionTypes,
            this.tabFamilyPackageContents,
            this.tabAdultPackageContents,
            this.tabFrequencies
        )
        let productId: string = PlanUtils.getProductId(
            this.tabFrequencies,
            this.tabPackages,
            this.tabAdultPackageContents
        )
        this.selectedOption = this.selectedOptions.filter(function(plan) {
            return plan.id === optionId && plan.product_id === productId
        })
    }
    // Initialize
    async created(): Promise<void> {
        const paramPackage: string = this.$route.params.package as string

        // eslint-disable-next-line no-console
        // console.log(this.$route.params)

        if (this.packages.includes(paramPackage)) {
            this.package = paramPackage
        }

        // If selected product is saved in local storage
        if (this.$store.state.customer.selectedProduct != null) {
            const selectedProduct = this.$store.state.customer.selectedProduct
            // Saved selected product(in local storage) is same as the package linked from LP
            if (selectedProduct.packageName === this.package) {
                this.tabPackages = selectedProduct.packageName
                this.tabSubscriptionTypes = selectedProduct.subscriptionType
                this.tabFrequencies = selectedProduct.frequency
                this.tabFamilyPackageContents = selectedProduct.familyPackageContent
            } else {
                this.tabPackages = this.package
                this.tabSubscriptionTypes = this.subscriptionTypes[0]
                this.tabFrequencies = this.tabFrequencies[0]
                this.tabFamilyPackageContents = this.familyPackageContents[0]
            }
        } else {
            this.tabPackages = this.package
            this.tabSubscriptionTypes = this.subscriptionTypes[0]
            this.tabFrequencies = this.tabFrequencies[0]
            this.tabFamilyPackageContents = this.familyPackageContents[0]
            this.tabAdultPackageContents = this.adultPackageContents[0]
        }
        this.packageChanged()

        // get product list from DB
        await this.$store.dispatch(ActionTypes.GET_PRODUCTS)
        if (this.$store.state.customer.products.length != 0) {
            this.selectedOptions = []
            let result = []
            for (let temp_product of this.$store.state.customer.products) {
                if (temp_product.option != null) {
                    for (let temp_option of temp_product.option.items) {
                        temp_option.original_price = temp_product.price
                        temp_option.contract_month = PlanUtils.getSubscriptionTypeNumber(
                            temp_option.id
                        )
                        temp_option.product_id = temp_product.id
                        result.push(temp_option)
                    }
                }
            }
            this.selectedOptions = result
        }
        this.getResult()
    }
    // on click "Signup"
    onSignupClicked() {
        // Save selected product to local storage
        let selectedProduct = this.selectedOption[0]
        selectedProduct.packageName = this.tabPackages
        selectedProduct.subscriptionType = this.tabSubscriptionTypes
        selectedProduct.frequency = this.tabFrequencies
        if (selectedProduct.packageName === 'family') {
            selectedProduct.familyPackageContent = this.tabFamilyPackageContents
        } else {
            selectedProduct.familyPackageContent = ''
        }
        selectedProduct.productId = PlanUtils.getProductId(
            this.tabFrequencies,
            this.tabPackages,
            this.tabAdultPackageContents
        )
        selectedProduct.optionId = PlanUtils.getOptionId(
            this.tabPackages,
            this.tabSubscriptionTypes,
            this.tabFamilyPackageContents,
            this.tabAdultPackageContents,
            this.tabFrequencies
        )
        this.$store.commit(ActionTypes.SAVE_OPTIONS, { product: selectedProduct })
        this.$router.push('/signup')
    }

    // Emit selectedProduct information to parent component
    @Watch('selectedOption')
    @Emit('returnValue')
    selectedOptionChanged() {
        return this.selectedOption[0]
    }
    // Receive "Emit" from child component : package
    packageValueChanged(tabValue: string): void {
        this.tabPackages = tabValue
        this.packageChanged()
        this.getResult()
    }
    // Receive "Emit" from child component : subscriptionType
    subscriptionTypeValueChanged(tabValue: string): void {
        this.tabSubscriptionTypes = tabValue
        this.getResult()
    }
    // Receive "Emit" from child component : frequency
    frequencyValueChanged(tabValue: string): void {
        this.tabFrequencies = tabValue
        this.getResult()
    }
    // Receive "Emit" from child component : familyPackageContents
    familyPackageContentsValueChanged(tabValue: string): void {
        this.tabFamilyPackageContents = tabValue
        this.getResult()
    }
    // Receive "Emit" from child component : familyPackageContents
    adultPackageContentsValueChanged(tabValue: string): void {
        this.tabAdultPackageContents = tabValue
        this.getResult()
    }

    newEvent = false
}
